<!-- 登录页面 -->
<template>
  <div class="v-login-page">
    <div class="v-login-wrap">
      <div class="v-login-box" :class="subjectType === '' ? 'v-login-box-main' : 'v-login-box'">
        <div class="v-arch" v-if="subjectType != ''"></div>
        <template v-if="subjectType != ''">
          <div class="v-login-card flex-start box-shadow-big">
            <div class="img-box">
              <img :src="language === 'en' ? loginImgEn :loginImg" alt="" />
            </div>
            <div class="v-login-r">
              <div class="v-register-flex ">
                <!-- <div @click="goBack">
                  <span class="theme-color font-size-13 goback" v-show="this.type == 'vLogin'">
                    <span class="iconfont iconfanhui"></span>
                    {{ $t('login2s.back') }}
                  </span>
                </div> -->
                <div></div>
                <!--右上角语音切换 和 返回首页-->
                <div class="v-en-zh text-right theme-icon-primary-color login-language">
                  <span class="pointer font-size-13" @click="goHome">{{$t('logins.backHome')}}</span>
                  <span :class="['iconfont', language == 'en' ? 'iconyuyanqiehuancon' : 'iconicon_A', 'pointer']"
                    @click="toggleLang"></span>
                </div>
              </div>

              <!-- 组件切换 -->
              <div class="v-login-content flex-center">
                <component :is="type" @callback="callback"></component>
              </div>
              <loginBottom v-if="subjectType != ''"></loginBottom>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="v-login-card box-shadow-big">
            <div class="img-box">
              <img :src="banner" alt="" />
            </div>
            <div class="v-login-r">
              <div v-if="subjectType != ''" class="v-register-flex ">
                <!-- <div @click="goBack">
                  <span class="theme-color font-size-13 goback" v-show="this.type == 'vLogin'">
                    <span class="iconfont iconfanhui"></span>
                    {{ $t('login2s.back') }}
                  </span>
                </div> -->
                <div></div>
                <!--右上角语音切换 和 返回首页-->
                <div class="v-en-zh text-right theme-icon-primary-color login-language">
                  <span class="pointer font-size-13" @click="goHome">{{$t('logins.backHome')}}</span>
                  <span :class="['iconfont', language == 'en' ? 'iconyuyanqiehuancon' : 'iconicon_A', 'pointer']"
                    @click="toggleLang"></span>
                </div>
              </div>

              <!-- 组件切换 -->
              <div class="v-login-content flex-center">
                <component :is="type" @callback="callback"></component>
              </div>

              <div v-if="subjectType == ''" class="v-register-flex-bot">
                <!--右上角语音切换 和 返回首页-->
                <div class="v-en-zh theme-icon-primary-color login-language color-white">
                  <span
                    :class="['iconfont', language == 'en' ? 'iconyuyanqiehuancon' : 'iconicon_A', 'pointer icon-span']"
                    class="m-l-0" @click="toggleLang"></span>
                  <span class="pointer font-size-18 m-l-9 back-span" @click="goHome">{{$t('logins.backHome')}}</span>
                </div>

                <!-- <div @click="goBack">
                  <span class="theme-color text-left font-size-13 goback" v-show="this.type == 'vLogin'">
                    <span class="iconfont iconfanhui"></span>
                    {{ $t('login2s.back') }}
                  </span>
                </div> -->
                <div></div>

              </div>

              <loginBottom v-if="subjectType != ''"></loginBottom>
            </div>

          </div>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import vLogin from '@/components/login/vLogin'
import vResetPasswords from '@/components/login/vResetPasswords'
import vExhibitorResetPassOrBindCode from '@/components/login/vExhibitorResetPassOrBindCode'
import vSelectIdentity from '@/components/login/vSelectIdentity'
import { removeToken } from '@/utils/auth'
import loginBottom from '@/components/login/loginBottom.vue'
import IN from '@/vendor/in.js'
// import banner from '@/assets/homeImages/banner.jpg'

export default {
  name: 'loginpage',
  components: {
    vLogin, //登录
    vResetPasswords, //忘记密码
    vExhibitorResetPassOrBindCode, //展商设置密码和绑定展商号
    vSelectIdentity, //切换身份
    loginBottom
  },
  data() {
    return {
      banner:'https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/PC/tangjiuhui/banner/login_banner.jpg',
      type: '',
      loginImg: 'https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/PC/tangjiuhui/login/img_cn.png',
      loginImgEn: 'https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/PC/tangjiuhui/login/img_en.png'

    }
  },
  computed: {
    ...mapGetters(['subjectType', 'language'])
  },
  created() {
    this.pageInit()
    this.watchIn()
    if (!this.subjectType) {
        window.PC.$RangersEventLoginAndRegister('selectidentity')
    }
  },
  methods: {
    goBack() {
      window.PC.$RangersEventLoginAndRegister('back')
      window.PC.$RangersEventLoginAndRegister('selectidentity')
      this.$store.commit('SET_SUBJECTTYPE', '')
      this.type = 'vSelectIdentity'
      this.loginSource()
    },
    callback(res) {
      if (res.path === 'vLogin') {
        window.PC.$RangersEventLoginAndRegister('selectidentity_click', {status: res.status})
      }
      if (res.type == 'switchComponents') {
        //切换组件
        this.type = res.path
      }
    },
    // 回首页
    goHome(){
      this.$router.push({path:'/'})
    },
    // 切换语音
    toggleLang() {
      window.PC.$RangersEventLoginAndRegister('language', null, () => {
        let lang = this.language == 'en' ? 'zh' : 'en'
        this.$store.commit('SET_LANGUAGE', lang)
        location.reload()
      })
    },
    // 页面初始化
    pageInit() {
      let type = this.$route.params ? this.$route.params.type : ''
      if (type) {
        type = type == 'person' ? 'visitor' : type
        this.$store.commit('SET_SUBJECTTYPE', type.toUpperCase())
        this.$store.commit('SET_TOKEN', '')
        removeToken()
      } else {
        this.$store.commit('SET_SUBJECTTYPE', 'visitor'.toUpperCase())
      }

      if (['ACTOR', 'VISITOR'].indexOf(this.subjectType) === -1) {
        //选则身份
        this.type = 'vSelectIdentity'
      } else {
        this.type = 'vLogin'
      }
    },
    // 监听是否是linkedin回调
    watchIn() {
      var _this = this;
      IN.watchIN(function() {
        _this.$store.commit('SET_SUBJECTTYPE', 'VISITOR')
        _this.type = 'vLogin'
      },null);
    }
  }
}
</script>
<style lang="stylus" scoped>
.goback {
    line-height 14px
    vertical-align middle
}
.color-white{
  background: $color-white !important;
  border-radius: 8px;
  padding: 7px 13px 5px 13px;
  box-shadow: 0px 2px 8px 0px #133781;
  .icon-span{
    font-size: 23px !important;
  }
  .back-span{
    line-height 17px;
  }
}
</style>
